import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { COLORS3 as COLORS, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const DeleteButton = styled(ButtonV3)`
  margin: ${SPACING.MD} 0 ${SPACING.XS};
  &:disabled {
    background-color: ${COLORS.WHITE_100};
  }
`;

export const DeleteSubtext = styled.p`
  color: ${COLORS.BLACK_100};
`;
